interface LinkInputSectionProps {
  value: string;
  onChange: (value: string) => void;
}

const LinkInputSection = ({value, onChange}: LinkInputSectionProps) => (
  <section className="mt-4">
    <label className="mb-3 text-gray-900">
      پیوست/ Link <span className="text-red-600">*</span>
    </label>
    <div className="flex items-center justify-center gap-2 w-full h-12 rounded border-2 p-2">
      <i className="icon-namelink text-xxl" />
      <input
        name="link"
        placeholder="لینک خود را در اینجا جایگذاری کنید"
        className="outline-none w-full"
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    </div>
  </section>
);

export default LinkInputSection;
